import { useEffect, useState } from 'react';

import { useEmbla } from '@hooks/use-embla';

export const useChipsSlider = (startIndex = 0) => {
    // Both isAtStart and isAtEnd can be true at the same time.
    // This indicates that all slides are in view and there's nothing to scroll.
    const [isAtStart, setIsAtStart] = useState(true);
    const [isAtEnd, setIsAtEnd] = useState(true);
    const { viewportRef, scrollPrev, scrollNext, emblaApi } = useEmbla({
        slidesToScroll: 1,
        speed: 5,
        containScroll: 'keepSnaps',
        align: 'start',
        startIndex: startIndex,
        dragFree: true,
    });

    useEffect(() => {
        if (emblaApi === undefined) return;

        const handleProgressChange = () => {
            const scrollProgress = emblaApi.scrollProgress();

            // scrollProgress is NaN when all slides fit into viewport and everything settled.
            // scrollProgress is +/- infinity if user scrolls when all slides fit into viewport.
            setIsAtStart(!Number.isFinite(scrollProgress) || scrollProgress <= 0);
            setIsAtEnd(!Number.isFinite(scrollProgress) || scrollProgress >= 1);
        };

        emblaApi.on('resize', handleProgressChange);
        emblaApi.on('scroll', handleProgressChange);
        emblaApi.on('settle', handleProgressChange);

        handleProgressChange();

        return () => {
            emblaApi.off('settle', handleProgressChange);
            emblaApi.off('scroll', handleProgressChange);
            emblaApi.off('resize', handleProgressChange);
        };
    }, [emblaApi]);

    // Reinitialization due to font loading
    useEffect(() => {
        if (emblaApi === undefined) return;

        setTimeout(() => {
            emblaApi.reInit();
        }, 500);
    }, [emblaApi]);

    return {
        isAtStart,
        isAtEnd,
        viewportRef,
        scrollPrev,
        scrollNext,
        emblaApi,
    };
};
